import React, { useEffect, useState } from 'react';
import { UseAxios } from '../Server-Api-Instance';
import '../Shared/CommonStyle.css';

const AgentDetails = ({ username }) => {
    const [agentName, setAgentName] = useState('');

    useEffect(() => {
        const fetchAgentName = async () => {
            try {
                const axios = UseAxios(false); // Pass true to use local URL
                const response = await axios.get(`/agent-details?username=${username}`);
                console.log("API Response:", response.data);
                if (response.status === 200) {
                    setAgentName(response.data.Agent_Name);
                } else {
                    console.error('Error fetching agent details:', response.status);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };
        console.log('agentName', agentName);
        fetchAgentName();
    }, [username]);

    return (
        <div className="heading-container">
            <h2 className="heading">{agentName}</h2>
        </div>
    );
};

export default AgentDetails;
